import { useMutation, useQuery } from "@tanstack/react-query";
import { adverseEventMedicationsApiService } from "./adverseeventmedications.api";

interface UseAdverseEventMedicationsOptions {
  adverseeventid?: number | null;
  enabled?: boolean;
}

export const useAdverseEventMedicationsApi = (options?: UseAdverseEventMedicationsOptions) => {
  const InsertMutation = useMutation({
    mutationFn: (data: any) => adverseEventMedicationsApiService.insertData(data),
  });

  const UpdateMutation = useMutation({
    mutationFn: (data: any) => adverseEventMedicationsApiService.updateData(data),
  });

  const SelectQuery = useQuery({
    queryKey: ["adverse-event-medications-select", options?.adverseeventid],
    queryFn: () =>
      adverseEventMedicationsApiService.getSelectById({
        adverseeventid: options?.adverseeventid,
      }),
    enabled: !!options?.adverseeventid && (options?.enabled ?? true),
  });

  const DeleteMutation = useMutation({
    mutationFn: (data: any) => adverseEventMedicationsApiService.deleteData(data),
  });

  return {
    InsertMutation,
    UpdateMutation,
    DeleteMutation,
    SelectQuery,
  };
};
